
import {Component, EventEmitter, Input, OnDestroy, Output} from '@angular/core';
import { FormGroup } from "@angular/forms";
import { Subscription } from "rxjs";
import { flyInOut } from "src/app/animations";
import { Question } from "src/app/classes/dynamic-form";
import { DynamicFormService } from "src/app/services/dynamic-form.service";
import { DataInput } from "@trivelope/triv-ui-tools-lib";




@Component( {
	selector: "question",
	templateUrl: "./question.component.html",
	styleUrl: "./question.component.scss",
	animations: [ flyInOut ]
})
export class QuestionComponent implements OnDestroy {


	q = new Question();
	@Input() set question( val: Question ) {
		this.q = val;
		this.initializeTrivInput();
	}

	dataInput: DataInput | null = null;

	fGroup!: FormGroup;
	@Input() set formGroup( val: FormGroup ) {
		this.fGroup = val;
		this.initializeTrivInput();
	}

  @Output() conditionValidityChange = new EventEmitter<boolean>();

	subscription = new Subscription();



	constructor(
		private dynamicFormService: DynamicFormService
	) {}


	private initializeTrivInput() {

		// initialize only if the question and the formGroup are known
		if( !this.q.id || !this.fGroup ) return;

		this.dataInput = new DataInput();
		this.dataInput.label = this.q.label;
		this.dataInput.id = this.dynamicFormService.CTRL_PREFIX + this.q.id;
		this.dataInput.type = this.q.type;
		this.dataInput.required = this.q.required;
		this.dataInput.defaultValue = this.q.value;
		this.dataInput.disabled = this.q.bIsDisabled;

		if( this.q.childrenCondition ) {
			this.dataInput.min = this.getMinInput( this.q.childrenCondition );
			this.dataInput.max = this.getMaxInput( this.q.childrenCondition );
			// this.dataInput.hint = "Bedingung: " + this.q.childrenCondition;
			this.dataInput.errorMsg = "Bedingung: " + this.q.childrenCondition;
		}


		const ctrlName = this.dataInput.id;
		// setTimeout so that the ctrl has enough time to be instanciated
		setTimeout( () => {

			const ctrl = this.fGroup.get( ctrlName );
			if( !ctrl ) {
				console.log( "ctrl not initialized ?!!", ctrlName );
				return;
			}
			this.subscription.add(
				ctrl.valueChanges.subscribe( value => {
					this.onValueChanged( value );
				})
			);

			this.onValueChanged( this.q.value );
		});


	}

	private getMinInput( childrenCondition: string ): number {

		if( !childrenCondition ) return 0;

		childrenCondition = childrenCondition.trim();
		if( childrenCondition.length < 2 ) {
			console.log( "invalid condition", childrenCondition );
			return 0;
		}

		const nCondition = +childrenCondition.substring(1);
		if( isNaN(nCondition) ) {
			console.log( "Invalid condition number", childrenCondition, nCondition );
			return 0;
		}

		const firstChar = childrenCondition.substring(0, 1);
		if( firstChar === ">" ) {
			return nCondition + 1;
		}
		else if( firstChar === "=" ) {
			return nCondition;
		}

		return 0;

	}

	private getMaxInput( childrenCondition: string ): number  {

		if( !childrenCondition ) return Number.MAX_SAFE_INTEGER;

		childrenCondition = childrenCondition.trim();
		if( childrenCondition.length < 2 ) {
			console.log( "invalid condition", childrenCondition );
			return Number.MAX_SAFE_INTEGER;
		}

		const nCondition = +childrenCondition.substring(1);
		if( isNaN(nCondition) ) {
			console.log( "Invalid condition number", childrenCondition, nCondition );
			return 0;
		}

		const firstChar = childrenCondition.substring(0, 1);
		if( firstChar === "=" ) {
			return nCondition;
		}
		else if( firstChar === "<" ) {
			return nCondition - 1;
		}

		return Number.MAX_SAFE_INTEGER;

	}


	private onValueChanged( value: any ) {

		let conditionValid = false;
		if( this.q.childrenCondition ) {
			conditionValid = this.checkConditionValidity(this.q.childrenCondition, value);
			if( conditionValid) {
				this.showKids();
			}
			else {
				this.hideKids( this.q );
			}
		}
		else if( !!value ) {
			this.showKids();
		}
		else {
			this.hideKids( this.q );
		}


		if( this.q.bIsLoop ) {
			this.dynamicFormService.manageLoopQuestion( this.q, +value );
		}


		if( this.q.excludesQuestionId && !this.q.bIsDisabled ) {

			this.dynamicFormService.manageExcludedQuestion( this.q );

		}

		this.conditionValidityChange.emit(conditionValid);

	}

	private hideKids( q: Question ) {

		for( const child of q.children ) {
			child.bIsVisible = false;
			this.recursiveHide( child );
		}

	}

	private recursiveHide( question: Question ) {

		question.bIsVisible = false;
		for( const child of question.children ) {
			this.recursiveHide( child );
		}

	}

	private showKids() {

		for( const child of this.q.children ) {
			child.bIsVisible = true;
		}

	}


	private checkConditionValidity( condition: string, value: boolean | string | number | null ): boolean {

		if( !condition ) return true;
		condition = condition.trim();
		if( !condition.length ) return true;

		if( condition === "true" ) return !!value;
		if( condition === "false" ) return !value;

		if( value === null ) return false;

		const firstChar = condition.substring( 0, 1 );
		if(  ( firstChar == ">" ) || ( firstChar == "<" ) || ( firstChar == "=" ) ) {

			const nCondition = +condition.substring( 1 );
			if( isNaN( nCondition ) ) {
				console.log( "invalid condition number", condition, nCondition );
				return false;
			}
			if( firstChar == ">" ) {
				const nValue = +value;
				return ( nValue > nCondition );
			}
			if( firstChar == "<" ) {
				const nValue = +value;
				return ( nValue < nCondition );
			}

			if( firstChar == "=" ) {
				const nValue = +value;
				return ( nValue == nCondition );
			}

		}

		console.log( "unknown condition", condition );
		return false;

	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}
	
}
